export const projects = [
  {
    title: "Todo List",
    subtitle: "ReactJS",
    description:
            "Use of CSS and JavaScript to create a to-do list to organize and prioritize your tasks.",
    image: "./project-todo.gif",
    link: "https://github.com/pankaj6673/TODO_APP",
  },
  {
    title: "Pomodoro Timer",
    subtitle: "React Native",
    description:
      "A Timer to help you not to procrastinate, be productive and stay focused on any task.",
    image: "./project-pomodoro.gif",
    link: "https://github.com/pankaj6673/Pomodoro",
  },
  {
    title: "BMI",
    subtitle: "React Native",
    description:
      "A simple BMI calculator that measure your body fat based on height and weight.",
    image: "./project-bmi.gif",
    link: "https://github.com/pankaj6673/BMI_APP",
  },
  {
    title: "App in development",
    subtitle: "ReactJS",
    description:
      " Stay tuned for the upcoming project which will be on creating a fitness app.",
    image: "./project-3.gif",
    link: "https://www.youtube.com/watch?v=dQw4w9WgXcQ",
  },
];

export const skills = [
  "JavaScript",
  "ReactJS",
  "Tailwind",
  "Node",
  "MySQL",
  "Python",
];



// WEBPACK FOOTER //
// ./src/data.js